import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_t9mynp4xpd: FaireBrandEntity = {
  token: "b_t9mynp4xpd",
  type: "brand",
  name: "Lovesoft",
  avatarUrl:
    "https://cdn.faire.com/fastly/b6f8d00dec3165fbbade78e98cd63f09335a2b8c02e6647560398a1b5bdfa792.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/849b551fa9aaacf72e2d1d7b409b64ab8677131b5ee62b53cf6b6d899415f122.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b6f8d00dec3165fbbade78e98cd63f09335a2b8c02e6647560398a1b5bdfa792.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/849b551fa9aaacf72e2d1d7b409b64ab8677131b5ee62b53cf6b6d899415f122.jpeg",
  location: "Madison, WI, USA",
  minimumOrderDollars: 149,
  rating: 4.8,
  reviewCount: 1390,
  isTopShop: true,
  isInsider: true,
  description:
    "At Lovesoft, we believe in the transformative power of yoga to connect the body, mind, and soul. As we expand into a comprehensive women’s fashion brand, our mission remains clear: to provide stylish, comfortable, and high-quality clothing that empowers women to feel free and celebrate life in every moment.\n\n✏️ Regarding brand labels, as we specialize in wholesale, they are typically not included unless specifically requested.\n✨ New Styles, Every Day – Discover fresh and unique designs crafted with care and precision from our in-house production.\n💪 Empowering Women – Our clothing is made to inspire confidence and comfort, whether you're practicing yoga, enjoying your day, or exploring new adventures.\n🌿 Eco-Friendly Focus – We are committed to using sustainable materials and practices that care for both our customers and the planet.\n🚚 Fast & Reliable Shipping – Our products ship from CT, CA, NJ, and LA.\n⏳ Order Flexibility – Orders can be canceled within 48 hours of placement. After that, they are processed into our warehouse system and can no longer be canceled.\n⚠️If the return is not due to a quality issue, the customer is responsible for return shipping. Items must be returned in their original packaging; returns without original packaging will not be accepted.\n\nYour satisfaction is our top priority! We’re always here to help with any order or shipping inquiries you may have.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:30.585Z",
    importedBy: "entity-db-cli",
  },
};
